import useLanguage, { useLanguagesData, useDefaultFlowLanguage } from 'FlowBuilder/hooks/useLanguageFlow';
import { useAct } from 'FlowTaker/store'
import { Fragment } from 'react';

export default function LanguageSwitcher() {
  const act = useAct()
  const activeLanguage = useLanguage()
  const desiredLanguage = useLanguage(false)
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleLanguageChange = (language) => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('lang', language);
    window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}`);
    act.local.upsert({ language });
    setDropdownOpen(false);
  }

  useEffect(() => {
    // On initial load, set local to active language
    act.local.upsert({ language: desiredLanguage });
  }, [])

  const { publishedLanguagesData } = useLanguagesData();
  const defaultLanguage = useDefaultFlowLanguage();

  if (Object.keys(publishedLanguagesData).length <= 1) {
    return <></>
  }

  const inactiveLanguages = Object.keys(publishedLanguagesData).filter(lang => lang !== activeLanguage);

  const activeFlag = publishedLanguagesData[activeLanguage]?.flag || publishedLanguagesData[defaultLanguage]?.flag || '🏳️';
  const activeName = publishedLanguagesData[activeLanguage]?.name || publishedLanguagesData[defaultLanguage]?.name || 'Unknown';

  return <div className="language-switcher-container">
      <div className="language-switcher">
      <>
        <div className='selected-language language-switcher-flag' key={activeLanguage + `-flag`} onClick={() => setDropdownOpen(!dropdownOpen)}>{activeFlag}</div>
        <div className='selected-language language-switcher-name' key={activeLanguage + `-name`} onClick={() => setDropdownOpen(!dropdownOpen)}>{activeName}</div>
        <div className='language-switcher-dropdown' onClick={() => setDropdownOpen(!dropdownOpen)}>{dropdownOpen ? '▲' : '▼'}</div>
      </>
      {inactiveLanguages.map(lang => {
        const data = publishedLanguagesData[lang];
        return (
          <Fragment key={lang}>
            <div className={`language-switcher-flag inactive-language ${dropdownOpen ? 'expanded' : 'collapsed'}`} key={lang + `-flag`} onClick={() => handleLanguageChange(lang)}>{data.flag}</div>
            <div className={`language-switcher-name inactive-language ${dropdownOpen ? 'expanded' : 'collapsed'}`} key={lang + `-name`} onClick={() => handleLanguageChange(lang)}>{data.name}</div>
          </Fragment>
        )
      })}
    </div>
  </div>
}
